"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setActiveTab = exports.myaccountSlice = exports.default = exports.MYACCCOUNT_TABS = void 0;
var _toolkit = require("@reduxjs/toolkit");
const MYACCCOUNT_TABS = exports.MYACCCOUNT_TABS = {
  planDetails: 'planDetails',
  paymentInfo: 'paymentInfo',
  updateProfile: 'updateProfile'
};
const initialState = {
  activeTab: MYACCCOUNT_TABS.planDetails
};
const myaccountSlice = exports.myaccountSlice = (0, _toolkit.createSlice)({
  name: 'myaccount',
  initialState,
  reducers: {
    setActiveTab(state, _ref) {
      let {
        payload
      } = _ref;
      state.activeTab = payload;
    }
  },
  extraReducers: {}
});
const {
  setActiveTab
} = myaccountSlice.actions;
exports.setActiveTab = setActiveTab;
var _default = exports.default = myaccountSlice.reducer;